<template>
  <div class="c-outages-nav">
    <div class="c-outages-nav__filter">
      <button class="c-outages-nav__filter-button">
        <label for="filter-current" class="c-outages-nav__filter-label">
          <input
            type="radio"
            class="c-outages-nav__filter-input"
            id="filter-current"
            value="current"
            v-model="filterOption"
          />
          CURRENT
        </label>
      </button>
      <button class="c-outages-nav__filter-button">
        <label for="filter-recent" class="c-outages-nav__filter-label">
          <input
            type="radio"
            class="c-outages-nav__filter-input"
            id="filter-recent"
            value="recent"
            v-model="filterOption"
          />
          RECENT
        </label>
        <outage-tooltip
          :tooltip-content="cmsContent.recentHelpContent"
          class="c-outages-nav__filter-tooltip"
        ></outage-tooltip>
      </button>
      <button class="c-outages-nav__filter-button">
        <label for="filter-scheduled" class="c-outages-nav__filter-label">
          <input
            type="radio"
            class="c-outages-nav__filter-input"
            id="filter-scheduled"
            value="scheduled"
            v-model="filterOption"
          />
          SCHEDULED
        </label>
      </button>
      <button class="c-outages-nav__filter-button" v-if="lvOutagesEnabled">
        <label for="filter-lv" class="c-outages-nav__filter-label">
          <input
            type="radio"
            class="c-outages-nav__filter-input"
            id="filter-lv"
            value="lv"
            v-model="filterOption"
          />
          INDIVIDUAL OUTAGES BY SUBURB
        </label>
      </button>
    </div>
    <div class="c-outages-nav__view">
      <button
        @click="updateOutagePageView('list')"
        class="c-outages-nav__view-button"
        :class="{
          'c-outages-nav__view-button--toggled': outagePageView === 'list',
        }"
      >
        <img src="_resources/app/client/assets/images/list-icon.svg" />
        <p class="c-outages-nav__view-label">LIST VIEW</p>
      </button>
      <button
        @click="updateOutagePageView('map')"
        class="c-outages-nav__view-button"
        :class="{
          'c-outages-nav__view-button--toggled': outagePageView === 'map',
        }"
      >
        <img src="_resources/app/client/assets/images/map-icon.svg" />
        <p class="c-outages-nav__view-label">MAP VIEW</p>
      </button>
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import OutageTooltip from "./OutageTooltip.vue";

export default {
  created() {},
  components: {
    OutageTooltip,
  },
  mounted() {},
  computed: {
    ...mapFields([
      "outagePageView",
      "filterOption",
      "cmsContent",
      "filterMarkerSelectedLocation",
      "matchMediaString",
      "lvOutagesEnabled",
    ]),
  },
  watch: {
    filterOption() {
      this.$store.commit("clearMarkerFilter");
    },
  },
  methods: {
    updateOutagePageView(view) {
      this.outagePageView = view;

      if (window.matchMedia(this.matchMediaString).matches) {
        this.$store.commit("resetMapView");
        this.$store.commit("clearAllFilters");
      }
    },
  },
};
</script>

<style lang="scss"></style>
